class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.item = $(this).closest('.productView');
        this.isFullWidth = this.item.closest('.product-full-width').length == 1 || this.item.closest('.product-full-width-2').length == 1;

        this.onVariantInit();
        this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantInit(){
        this.updateOptions();
        this.updateMasterId();
        this.updateMedia(1500, 'init');
        // this.updateURL();
        this.renderProductAjaxInfo();
        this.renderProductInfo();
        this.updateVariantStatuses();
        this.updateHotSaleSwatches();
        if (!this.currentVariant) {
            this.updateAttribute(true);
        } else {
            this.updateAttribute(false, !this.currentVariant.available);
        }
        this.updateLegacyProductState();
    }
    
    onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();
        this.updatePickupAvailability();
        this.updateVariantStatuses(event.target);
        this.updateHotSaleSwatches();
      
        if (!this.currentVariant) {
            this.updateAttribute(true);
            this.updateStickyAddToCart(true);
        } else {
            this.updateMedia(200, 'change');
            if (!document.querySelector('.featured-product')) {
                this.updateURL();
            }
            this.updateVariantInput();
            this.updateLegacyPriceSummary();
            this.updateBadgeSale();
            this.renderProductAjaxInfo();
            this.renderProductInfo();
            this.updateProductInfo();
            this.updateAttribute(false, !this.currentVariant.available);
            this.updateStickyAddToCart(false, !this.currentVariant.available);
            this.checkQuantityWhenVariantChange();
            this.updateLegacyProductState();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    decodeOptions() {
        this.options = this.options.map(option => {
            const parsedOption = this.decodeOption(option)
            return parsedOption
        })
    }
  
    decodeOption(option) {
      if (option) {
          return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/')
        } else {
          return null
        }
    }

    encodeOption(option) {
        if (option) {
          return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash')
        } else {
          return null
        }
    }
    
    updateMasterId() {
        this.decodeOptions()
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });

        if (this.item.find('[data-filter]').length && this.currentVariant?.featured_media && this.currentVariant.featured_media.alt != null) {
            this.item.find('[data-filter]:checked').attr('data-value-default-lang', this.currentVariant?.featured_media.alt.toLowerCase().replace(/ /g,"-"));
        }
    }      

    updateMedia(time, status) {
        const enableVariantImageGroup = document?.querySelector('.enable_variant_image_group');
    
        if (enableVariantImageGroup && status == 'init') return;

        setTimeout(() => {
            if (!this.currentVariant || !this.currentVariant?.featured_media || document.querySelector('.productView-nav')?.matches('.media-filter')) return;
            
            const newMedia = document.querySelectorAll(
                `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
            );
    
            if (!newMedia) return;
            window.setTimeout(() => {
                if ($('.productView-nav-gallery').length > 0) {
                    const newMediaGallery = document.querySelector(`.slick-slide:not(.slick-cloned):has([data-media-id="${this.currentVariant.featured_media.id}"])`)?.getAttribute("data-slick-index");
                    $('.productView-nav-gallery').slick('slickGoTo', newMediaGallery);
                } else{
                    $(newMedia).trigger('click');
                }
            }, time);
    
            if (!this.isFullWidth || window.innerWidth < 768 || !this.currentVariant) return;
            const mediaId = this.currentVariant.featured_media.id;
            const activeMedia = document?.querySelector(`.product-single__media[data-media-id="${mediaId}"]`);
            const fallbackImageContainer = document?.querySelector('.productView-image[data-index="1"]');

            if (activeMedia) {
                setTimeout(() => {
                    activeMedia.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 20);
            } else {
                const fallbackImage = fallbackImageContainer?.querySelector('img');
                const featuredImage = this.currentVariant?.featured_image;
                if (!featuredImage || !fallbackImage) return;

                fallbackImage.setAttribute('src', featuredImage.src);
                fallbackImage.setAttribute('srcset', featuredImage.src);
                fallbackImage.setAttribute('alt', featuredImage.alt);

                setTimeout(() => {
                    fallbackImageContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 20);
            }
        }, 1)
    }

    scrollToBlock(block) {
        const headerHeight = document.querySelectorAll('.section-header-navigation')[0]?.getBoundingClientRect().height 
        const announcementBarHeight = document.querySelectorAll('.announcement-bar')[0]?.getBoundingClientRect().height 
        const positionTop = block.getBoundingClientRect().top - headerHeight - announcementBarHeight 

        window.scrollTo({
            top: positionTop,
            behavior: 'smooth'
        })
    }

    updateURL() {
        if (!this.currentVariant) return;
        window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}`);

        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant?.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    renderProductAjaxInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `product-price-${this.dataset.product}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(id);
                const source = html.getElementById(id);

                const property = `product-property-${this.dataset.product}`;
                const destinationProperty = document.getElementById(property);
                const sourceProperty = html.getElementById(property);

                if (source && destination) {
                    destination.innerHTML = source.innerHTML;
                    this.updateLegacyPriceSummary();
                }

                if (this.checkNeedToConvertCurrency()) {
                    let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');

                    Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                }

                if(destinationProperty) {
                    if (sourceProperty) {
                        destinationProperty.innerHTML = sourceProperty.innerHTML;
                        destinationProperty.style.display = 'table';
                    } else{
                        destinationProperty.style.display = 'none';
                    }
                } else if (sourceProperty) {
                    document.querySelector('.productView-product').insertBefore(sourceProperty, document.querySelector('.productView-options'));
                }

                document.getElementById(`product-price-${this.dataset.product}`)?.classList.remove('visibility-hidden');
                this.updateBadgeSale()
        });
    }

    renderProductInfo() {
        if(this.item.find('[data-sku]').length > 0){
            this.item.find('[data-sku] .productView-info-value').text(this.currentVariant.sku);
        }

        if(this.item.find('[data-barcode]').length > 0){
            this.item.find('[data-barcode] .productView-info-value').text(this.currentVariant.barcode);
        }

        var inventory = this.currentVariant?.inventory_management;

        if(inventory != null) {
            var arrayInVarName = `product_inven_array_${this.dataset.product}`,
                inven_array = window[arrayInVarName];

            if(inven_array != undefined) {
                var inven_num = inven_array[this.currentVariant.id],
                    inputQuantity = this.item.find('input[name="quantity"]'),
                    buttonSubmit = this.item.find('button#product-add-to-cart'),
                    inventoryQuantity = parseInt(inven_num);

                if(inputQuantity.length > 0) {
                    inputQuantity.attr('data-inventory-quantity', inventoryQuantity);
                } else {
                    buttonSubmit.attr('data-inventory-quantity', inventoryQuantity);
                }

                if(this.item.find('[data-inventory]').length > 0){
                    if(inventoryQuantity > 0){
                        const showStock = this.item.find('[data-inventory]').data('stock-level');
                        if (showStock == 'show') {
                            this.item.find('[data-inventory] .productView-info-value').text(inventoryQuantity+' '+window.inventory_text.inStock);
                        }
                        else {
                            this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.inStock);
                        }
                    } else {
                        this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.outOfStock);
                    }
                }

                hotStock(inventoryQuantity);
            }
        }

        if(this.item.find('.productView-stickyCart').length > 0){
            const sticky = this.item.find('.productView-stickyCart');
            const optionSticky = sticky.find('.select__select');

            optionSticky.val(this.currentVariant.id);
        }
    }

    updateProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const description = `[data-product-description-${this.dataset.product}]`
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destinationDesc = document.querySelector(description);
                const sourceDesc = html.querySelector(description);

                if (sourceDesc && destinationDesc) {
                    destinationDesc.innerHTML = sourceDesc.innerHTML;
                    if (destinationDesc.closest('.toggle-content--height')){
                        destinationDesc.style.maxHeight = null;
                    }
                }
        });
    }

    updateAttribute(unavailable = true, disable = true){
        const addButton = document.getElementById(`product-form-${this.dataset.product}`)?.querySelector('[name="add"]');
        var quantityInput = this.item.find('input[name="quantity"]'),
            notifyMe = this.item.find('.productView-notifyMe'),
            hotStock = this.item.find('.productView-hotStock'),
            buttonAddtocart = this.item.find('.product-form__submit'),
            maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));

        if (isNaN(maxValue)) {
            maxValue = maxValue = parseInt(buttonAddtocart.attr('data-inventory-quantity'));
        } else {
            maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
        }
        
        if(unavailable){
            var text = window.variantStrings.unavailable;

            quantityInput.attr('disabled', true);
            notifyMe.slideUp('slow');
            if (addButton != null){
                addButton.setAttribute('disabled', true);
                addButton.textContent = text;
            }
            quantityInput.closest('quantity-input').addClass('disabled');

            if(hotStock.length > 0) hotStock.addClass('is-hiden');
        } else {
            if (disable) {
                var text = window.variantStrings.soldOut,
                    subTotal = 0,
                    price = this.currentVariant?.price;

                const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
                const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');

                if (window.subtotal.show) {
                    let qty = quantityInput.val() || 1;

                    subTotal = qty * price;
                    subTotal = Shopify.formatMoney(subTotal, window.money_format);
                    subTotal = extractContent(subTotal);

                    const moneySpan = document.createElement('span')
                    moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal')
                    moneySpan.innerText = subTotal
                    document.body.appendChild(moneySpan)

                    if (this.checkNeedToConvertCurrency()) {
                        let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                    }

                    subTotal = moneySpan.innerText
                    $(moneySpan).remove()

                    if (window.subtotal.style == '1') {
                        const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');
                        if (pdView_subTotal != null) {
                            pdView_subTotal.textContent = subTotal;
                        }
                    } else if (window.subtotal.style == '2') {
                        text = window.subtotal.text.replace('[value]', subTotal);
                    }
                } else {
                    subTotal = Shopify.formatMoney(price, window.money_format);
                    subTotal = extractContent(subTotal);
                }

                quantityInput.attr('data-price', this.currentVariant?.price);
                quantityInput.attr('disabled', true);
                if (addButton != null){
                    addButton.setAttribute('disabled', true);
                    addButton.textContent = text;
                }
                quantityInput.closest('quantity-input').addClass('disabled');

                if (subTotal != 0 && stickyPrice.length) {
                    stickyPrice.text(subTotal);
                }

                // 吸底加购不再以变体自身 compare_at_price 作为划线价展示（对比价大于正价时只展示正价）。
                // 划线价仅在「多买(Buy More Save More)」折扣生效时由 sticky-add-to-cart.js 单独处理。
                const thisStickyPrice = $('[data-sticky-add-to-cart] .sticky-price');
                const thisComparePrice = $('[data-sticky-add-to-cart] .money-compare-price');

                thisStickyPrice.removeClass('has-compare-price');
                thisComparePrice.remove();

                if (notifyMe.length > 0) {
                    notifyMe.find('.halo-notify-product-variant').val(this.currentVariant.title);
                    notifyMe.find('.notifyMe-text').empty();
                    notifyMe.slideDown('slow');
                }
            } else {
                var text,
                    subTotal = 0,
                    price = this.currentVariant?.price;

                const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');

                if (window.subtotal.show) {
                    let qty = quantityInput.val() || 1;

                    subTotal = qty * price;
                    subTotal = Shopify.formatMoney(subTotal, window.money_format);
                    subTotal = extractContent(subTotal);

                    const moneySpan = document.createElement('span')
                    moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal')
                    moneySpan.innerText = subTotal
                    document.body.appendChild(moneySpan)

                    if (this.checkNeedToConvertCurrency()) {
                        let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                    }

                    subTotal = moneySpan.innerText
                    $(moneySpan).remove()

                    if (window.subtotal.style == '1') {
                        const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');
                        if (pdView_subTotal != null) {
                            pdView_subTotal.textContent = subTotal;
                        }

                        if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                            text = window.variantStrings.preOrder;
                        } else {
                            text = window.variantStrings.addToCart;
                        }
                    } else if (window.subtotal.style == '2') {
                        if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                            text = window.variantStrings.preOrder;
                        } else {
                            text = window.subtotal.text.replace('[value]', subTotal);
                            $('#show-sticky-product').text(text);
                            $('#product-sticky-add-to-cart').text(text);
                        }
                    }
                } else {
                    subTotal = Shopify.formatMoney(price, window.money_format);
                    subTotal = extractContent(subTotal);
                    if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                        text = window.variantStrings.preOrder;
                    } else {
                        text = window.variantStrings.addToCart;
                    }
                }

                quantityInput.attr('data-price', this.currentVariant?.price);
                quantityInput.attr('disabled', false);
                if (addButton != null){
                    addButton.removeAttribute('disabled');
                    addButton.textContent = text;
                }
                quantityInput.closest('quantity-input').removeClass('disabled');

                if (subTotal != 0 && stickyPrice.length) {
                    stickyPrice.text(subTotal);
                }

                // 吸底加购不再以变体自身 compare_at_price 作为划线价展示（对比价大于正价时只展示正价）。
                // 划线价仅在「多买(Buy More Save More)」折扣生效时由 sticky-add-to-cart.js 单独处理。
                const thisStickyPrice = $('[data-sticky-add-to-cart] .sticky-price');
                const thisComparePrice = $('[data-sticky-add-to-cart] .money-compare-price');

                thisStickyPrice.removeClass('has-compare-price');
                thisComparePrice.remove();

                if (notifyMe.length > 0) {
                    notifyMe.slideUp('slow');
                }
            }
        }
    }

    updateStickyAddToCart(unavailable = true, disable = true){
        if(this.item.find('.productView-stickyCart').length > 0){
            const sticky = this.item.find('.productView-stickyCart');
            const itemImage = sticky.find('.sticky-image');
            const option = sticky.find('.select__select');
            const input = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('input[name="id"]');
            const button = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('[name="add"]');
            var quantityInput = this.item.find('input[name="quantity"]');
            var submitBtn = $('.product-form__submit');
            var maxValue;

            if (quantityInput.length > 0) {
                maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
            } else {
                maxValue = parseInt(submitBtn.attr('data-inventory-quantity'));
            }
          
            if(unavailable){
                var text = window.variantStrings.unavailable;

                button.setAttribute('disabled', true);
                button.textContent = text;
            } else {
                if (!this.currentVariant) return;

                const image = this.currentVariant?.featured_image;
                
                if (image != null) {
                    itemImage.find('img').attr({
                        'src': image.src,
                        'srcset': image.src,
                        'alt': image.alt
                    });
                }

                option.val(this.currentVariant.id);

                if (disable) {
                    var text = window.variantStrings.soldOut;

                    button.setAttribute('disabled', true);
                    button.textContent = text;
                } else {
                    if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                        text = window.variantStrings.preOrder;
                    } else {
                        text = window.variantStrings.addToCart;
                    }

                    button.removeAttribute('disabled');
                    button.textContent = text;
                }

                input.value = this.currentVariant.id;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    checkNeedToConvertCurrency() {
        var currencyItem = $('.dropdown-item[data-currency]');
        if (currencyItem.length && typeof Currency !== 'undefined' && typeof Currency.convertAll === 'function') {
            const activeShopCurrency = typeof shopCurrency !== 'undefined' ? shopCurrency : window.shop_currency;
            return (window.show_multiple_currencies && Currency.currentCurrency != activeShopCurrency) || window.show_auto_currency;
        } else {
            return;
        }
    }

    checkQuantityWhenVariantChange() {
        var quantityInput = this.closest('.productView-details').querySelector('input.quantity__input')
        var maxValue = parseInt(quantityInput?.dataset.inventoryQuantity);
        var inputValue = parseInt(quantityInput?.value);

        let value = inputValue 

        if (inputValue > maxValue && maxValue > 0) {
            value = maxValue
        } else {
            value = inputValue
        }

        if (value < 1 || isNaN(value)) value = 1 
      
        if (quantityInput) {
          quantityInput.value = value
        }
      
        // document.getElementById('product-add-to-cart').dataset.available = this.currentVariant.available && maxValue <= 0
        const elementProductAddToCart = document.getElementById('product-add-to-cart');
        if (elementProductAddToCart && this.currentVariant?.available !== undefined && typeof maxValue !== 'undefined') {
            elementProductAddToCart.dataset.available = this.currentVariant.available && maxValue <= 0;
        }
    }

    updateVariantStatuses(target) {
        // const options = this.item.find('.productView-details .product-form__input'),
        //     optionsLength = options.length,
        //     pvOptionsLength = PVoptions.length,
        //     checkStickyVariant = false;
      
        // optionsLength > pvOptionsLength ? checkStickyVariant = true : '';

        const selectedOptionOneVariants1 = this.variantData.filter(variant => this.querySelectorAll(':checked')[0]?.value === variant.option1);
        const selectedOptionOneVariants2 = this.variantData.filter(variant => this.querySelectorAll(':checked')[1]?.value === variant.option2);
        const selectedOptionOneVariants3 = this.variantData.filter(variant => this.querySelectorAll(':checked')[2]?.value === variant.option3);
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        const inputLength = inputWrappers.length;
        const variant_swatch = [...this.querySelectorAll('.product-form__swatch')];
        inputWrappers.forEach((option, index) => {
            option.querySelector('[data-header-option]').innerText = option.querySelector(':checked').value;
            if (index === 0 && inputLength > 1) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
            const previousOptionSelected = inputLength > 1 ? inputWrappers[index - 1].querySelector(':checked').value : inputWrappers[index].querySelector(':checked').value;
            const optionInputsValue = inputLength > 1 ? selectedOptionOneVariants1.filter(variant => variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]) : this.variantData.map(variantOption => variantOption[`option${ index + 1 }`]);
            const availableOptionInputsValue = inputLength > 1 ? selectedOptionOneVariants1.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]) : this.variantData.filter(variant => variant.available).map(variantOption => variantOption[`option${ index + 1 }`]);
            this.setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue)
        });
        if (variant_swatch.length > 1 && target){
            if(target.parentElement.parentElement.dataset.optionIndex == 0) this.updateImageSwatch(selectedOptionOneVariants1, target.parentElement.parentElement.dataset.optionIndex);
            if(target.parentElement.parentElement.dataset.optionIndex == 1) this.updateImageSwatch(selectedOptionOneVariants2, target.parentElement.parentElement.dataset.optionIndex);
            if(target.parentElement.parentElement.dataset.optionIndex == 2) this.updateImageSwatch(selectedOptionOneVariants3, target.parentElement.parentElement.dataset.optionIndex);
        }
    }

    updateImageSwatch(selectedOptionOneVariants,optionIndex) {
        const inputWrappers = this.querySelectorAll('.product-form__input');
        if(inputWrappers){
            inputWrappers.forEach((element, inputIndex) => {
                const imageSpan = element.querySelectorAll("label>span.pattern");
                const imageLabel = element.querySelectorAll("label");
                const imageSpanImage = element.querySelectorAll("label>span.expand>img");
                const inputList = element.querySelectorAll("input");

                inputList.forEach((item, index) => {
                    if(inputIndex != optionIndex){
                        const image = selectedOptionOneVariants.filter(tmp => {
                            if (inputIndex == 0) return tmp.option1 == item.value;
                            if (inputIndex == 1) return tmp.option2 == item.value;
                            if (inputIndex == 2) return tmp.option3 == item.value;
                        });
    
                        if(image.length > 0) {
                            imageLabel[index].style.display = "inline-block";
                            var remainingOptionValue = inputWrappers[3 - inputIndex - optionIndex]?.querySelector(':checked').value;
                            let activeIndex = 0;
                                
                            for (let i = 0; i < image.length; i++) {
                                const imageItem = image[i];
                                const title = imageItem.title;

                                if (title.includes(remainingOptionValue)) {
                                    activeIndex = i;
                                }
                            }
                            
                            if (imageSpan[index] != undefined && image[activeIndex].featured_image != null) imageSpan[index].style.backgroundImage = `url("${image[activeIndex].featured_image.src}")`;
                            if (imageSpanImage[index] != undefined && image[0].featured_image != null) imageSpanImage[index].srcset = image[0].featured_image.src;
                        }
                    }
                    // else {
                    //     imageLabel[index].style.display = "none";
                    // }
                })
            });
        }
    }

    setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue) {
        optionInputs.forEach(input => {
            if (availableOptionInputsValue.includes(input.getAttribute('value'))) {
                input.classList.remove('soldout');
                input.innerText = input.getAttribute('value');
            } else {
                input.classList.add('soldout');
                optionInputsValue.includes(input.getAttribute('value')) ? input.innerText = input.getAttribute('value') + ' (Sold out)' : input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'))
            }
        });
    }

    updateBadgeSale() {
        const productView = this.item[0] || document;
        let badgeWrap = productView.querySelector(".productView-badge");

        if (!badgeWrap) return;

        let badgeText = badgeWrap.querySelector(".productView-badge .badge.sale-badge"),
            badgeTextSaleType = badgeWrap.getAttribute('data-text-sale-badge') || '-',
            priceCompare = this.currentVariant ? Number(this.currentVariant.compare_at_price || 0) : Number(productView.querySelector(".productView-product .price__compare")?.getAttribute('data-compare') || 0),
            priceLast = this.currentVariant ? Number(this.currentVariant.price || 0) : Number(productView.querySelector(".productView-product .price__sale .price__last")?.getAttribute('data-last') || 0),
            hasSale = priceCompare > priceLast,
            percentSale = hasSale ? Math.round(((priceCompare - priceLast) / priceCompare) * 100) : 0;

        function getBadgeText(text, percent) {
            const saleType = (text || '').trim();
            if (saleType === '-') return `-${percent}%`;
            return `${saleType} ${percent}%`.trim();
        }

        function renderSpan(text) {
            let spanElement = document.createElement('span');
            spanElement.classList.add('badge', 'sale-badge');
            const anchor = badgeWrap.querySelector('[data-presale-badge], .bundle-badge, .sold-out-badge');
            if (anchor) {
                badgeWrap.insertBefore(spanElement, anchor);
            } else {
                badgeWrap.appendChild(spanElement);
            }
            spanElement.innerText = text;
        }

        if (badgeWrap.classList.contains("has-badge-js")) {
            if (!hasSale) {
                badgeWrap.querySelector(".badge.sale-badge")?.remove();
                badgeWrap.classList.add('sale_badge_disable');
            } else {
                const saleText = getBadgeText(badgeTextSaleType, percentSale);
                badgeWrap.classList.remove('sale_badge_disable');
                if (!badgeText) {
                    renderSpan(saleText)
                } else {
                    badgeText.innerText = saleText
                }
            }
        } else {
            if (!hasSale) {
                badgeWrap.querySelector(".badge.sale-badge")?.remove();
                badgeWrap.classList.add('sale_badge_disable');
            } else {
                badgeWrap.classList.remove('sale_badge_disable');
                if (!badgeText) {
                    renderSpan(badgeTextSaleType.trim());
                } else {
                    badgeText.innerText = badgeTextSaleType.trim()
                }
            }
        }
    }

    updateLegacyPriceSummary() {
        if (!this.currentVariant) return;

        const priceContainer = this.item[0]?.querySelector(`#product-price-${this.dataset.product}.productView-price--legacy`);
        if (!priceContainer) return;

        const priceRoot = priceContainer.querySelector('.price');
        const saleBlock = priceRoot?.querySelector('.price__sale');
        if (!priceRoot || !saleBlock) return;

        const price = Number(this.currentVariant.price || 0);
        const compareAtPrice = Number(this.currentVariant.compare_at_price || 0);
        const hasSale = compareAtPrice > price;
        const formattedPrice = formatProductMoney(price);
        const formattedComparePrice = hasSale ? formatProductMoney(compareAtPrice) : '';
        const savedMoney = hasSale ? formatProductMoney(compareAtPrice - price) : '';
        const savedPercent = hasSale ? Math.round(((compareAtPrice - price) * 100) / compareAtPrice) : 0;

        priceRoot.classList.toggle('price--on-sale', hasSale);
        priceRoot.classList.toggle('price--sold-out', !this.currentVariant.available);

        const regularPrice = priceRoot.querySelector('.price__regular .price-item');
        const salePrice = saleBlock.querySelector('.price__last .price-item');
        const salePriceWrapper = saleBlock.querySelector('.price__last');
        const compareWrapper = saleBlock.querySelector('.price__compare');
        const comparePrice = compareWrapper?.querySelector('.price-item');

        if (regularPrice) regularPrice.textContent = formattedPrice;
        if (salePrice) salePrice.textContent = formattedPrice;
        if (salePriceWrapper) salePriceWrapper.setAttribute('data-last', price);

        if (compareWrapper) {
            if (hasSale) {
                compareWrapper.setAttribute('data-compare', compareAtPrice);
            } else {
                compareWrapper.removeAttribute('data-compare');
            }
        }
        if (comparePrice) comparePrice.textContent = formattedComparePrice;

        let savedLine = saleBlock.querySelector('.price__saved');
        if (hasSale) {
            if (!savedLine) {
                savedLine = document.createElement('div');
                savedLine.className = 'price__saved price__saved--legacy-summary';
                const savedItem = document.createElement('span');
                savedItem.className = 'price-item price-item--saved';
                savedLine.appendChild(savedItem);
                const saleLabel = saleBlock.querySelector('.price__label_sale');
                if (saleLabel) {
                    saleBlock.insertBefore(savedLine, saleLabel);
                } else {
                    saleBlock.appendChild(savedLine);
                }
            }
            const savedItem = savedLine.querySelector('.price-item--saved') || savedLine;
            savedItem.textContent = `You Save ${savedMoney} (${savedPercent}% off)`;
        } else {
            savedLine?.remove();
        }

        let saleLabel = saleBlock.querySelector('.price__label_sale');
        if (hasSale) {
            if (!saleLabel) {
                saleLabel = document.createElement('dd');
                saleLabel.className = 'price__label_sale price__label_percent';
                const label = document.createElement('span');
                label.className = 'label_sale label_sale_percent';
                saleLabel.appendChild(label);
                saleBlock.appendChild(saleLabel);
            }
            const saleLabelText = saleLabel.querySelector('.label_sale') || saleLabel;
            saleLabelText.textContent = `(-${savedPercent}%)`;
        } else {
            saleLabel?.remove();
        }
    }

    getVariantMetafields(variantId = this.currentVariant?.id) {
        const variantMetafields = window[`product_variant_metafields_${this.dataset.product}`] || {};
        return variantId && variantMetafields[variantId] ? variantMetafields[variantId] : {};
    }

    metafieldValueIsTrue(value) {
        return value === true || value === 'true' || value?.value === true || value?.value === 'true';
    }

    getCurrentPresaleInfo() {
        return this.getVariantMetafields()?.presale_info || {};
    }

    isCurrentVariantPresale() {
        return this.metafieldValueIsTrue(this.getCurrentPresaleInfo()?.isPresale);
    }

    updateLegacyProductState() {
        this.updateHotSaleSwatches();
        if (!this.currentVariant) return;

        this.updateLegacyPriceSummary();
        this.updateBadgeSale();
        this.updateLegacyTitle();
        this.updateLegacyFlashSaleTag();
        this.updateLegacyPresaleState();
        updateProductLevelDiscount(this.dataset.product, null, this.currentVariant.price);
    }

    updateLegacyTitle() {
        const metafields = this.getVariantMetafields();
        const title = metafields.variant_custom_name || this.currentVariant.name || this.item.find('[data-product-title]').data('default-title');

        if (!title) return;

        this.item.find('[data-product-title-text]').text(title);
        this.item.find('[data-sticky-add-to-cart] .sticky-title').text(title);
    }

    updateLegacyFlashSaleTag() {
        if (this.item.find('[data-static-flash-sale-tag]').length > 0) return;

        const metafields = this.getVariantMetafields();
        const showFlashSale = this.metafieldValueIsTrue(metafields.is_flash_sale);
        const tag = this.item.find('[data-variant-flash-sale-tag]');

        if (tag.length > 0) {
            tag.toggleClass('hidden', !showFlashSale);
        }
    }

    updateLegacyPresaleState() {
        const isPresale = this.isCurrentVariantPresale();
        const presaleInfo = this.getCurrentPresaleInfo();
        const delay = presaleInfo?.delayDays;
        const presaleText = delay ? `Presale: Ship within ${delay} days` : 'Presale';
        const presaleBox = this.item.find('[data-presale-box]');

        if (presaleBox.length > 0) {
            presaleBox.toggleClass('hidden', !isPresale);
            presaleBox.find('[data-presale-text]').text(presaleText);
        }

        this.item.find('[data-presale-badge]').toggleClass('hidden', !isPresale);

        // Toggle product-presale-information snippet visibility by variant id
        const variantId = this.currentVariant?.id;
        const formButtons = this.item.find('.product-form__buttons .product-customInformation .pre-sale-box');
        formButtons.removeClass('show').hide();
        if (isPresale && variantId) {
            const presaleButton = this.item.find('.product-form__buttons').find(`[data-variant-id="${variantId}"] .pre-sale-box`);
            presaleButton.addClass('show').show();
        }

        if (isPresale && this.currentVariant.available) {
            this.item.find('#product-add-to-cart, #product-sticky-add-to-cart').each((index, button) => {
                if (!button.disabled) button.textContent = window.variantStrings.preOrder;
            });
        }
    }

    updateHotSaleSwatches() {
        const variantData = this.getVariantData();

        this.querySelectorAll('.swatch-hot-variant').forEach(span => {
            span.classList.remove('swatch-hot-variant');
        });

        if (!variantData || !variantData.length) return;

        const fieldsets = [...this.querySelectorAll('.product-form__input')];
        const checkedArr = [...this.querySelectorAll('.product-form__input input:checked')];

        fieldsets.forEach((fieldset, index) => {
            const inputs = [...fieldset.querySelectorAll('input[type="radio"]')];
            if (!inputs.length) return;
            const optionLevel = index + 1;

            inputs.forEach(input => {
                const labelDom = input.nextElementSibling?.querySelector('span.text, span.pattern');
                if (!labelDom) return;

                const matchedVariant = variantData.find(variant => {
                    if (!variant.metafields?.custom?.hot_sale) return false;
                    if (!variant.available) return false;

                    switch (optionLevel) {
                        case 1:
                            return input.value === variant.option1;
                        case 2:
                            return checkedArr[0]?.value === variant.option1 && input.value === variant.option2;
                        case 3:
                            return checkedArr[0]?.value === variant.option1 && checkedArr[1]?.value === variant.option2 && input.value === variant.option3;
                        default:
                            return false;
                    }
                });

                if (matchedVariant) {
                    labelDom.classList.add('swatch-hot-variant');
                }
            });
        });
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue) {
        let fallbackInput = null;

        optionInputs.forEach(input => {
            const inputValue = input.getAttribute('value');
            const inputLabel = input.nextElementSibling;
            const optionExists = optionInputsValue.includes(inputValue);

            if (availableOptionInputsValue.includes(inputValue)) {
                inputLabel.classList.remove('soldout', 'unavailable');
                inputLabel.classList.add('available');
            } else {
                inputLabel.classList.remove('available', 'unavailable');
                inputLabel.classList.add('soldout');

                if (window.variantStrings.hide_variants_unavailable && !optionExists) {
                    inputLabel.classList.add('unavailable');
                }

                if (input.checked && availableOptionInputsValue.length > 0) {
                    fallbackInput = optionInputs.find((optionInput) => optionInput.getAttribute('value') === availableOptionInputsValue[0]);
                } else if (input.checked && !optionExists && optionInputsValue.length > 0) {
                    fallbackInput = optionInputs.find((optionInput) => optionInput.getAttribute('value') === optionInputsValue[0]);
                }
            }
        });

        if (fallbackInput && !fallbackInput.checked) {
            fallbackInput.checked = true;
            this.dispatchEvent(new Event('change'));
        }
    }
        
    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
}

customElements.define('variant-radios', VariantRadios);

function shouldConvertProductMoney() {
    const currencyItem = $('.dropdown-item[data-currency]');
    if (!currencyItem.length || typeof Currency === 'undefined' || typeof Currency.convertAll !== 'function') return false;

    const activeShopCurrency = typeof shopCurrency !== 'undefined' ? shopCurrency : window.shop_currency;
    return (window.show_multiple_currencies && Currency.currentCurrency != activeShopCurrency) || window.show_auto_currency;
}

function formatProductMoney(cents) {
    let formatted = Shopify.formatMoney(cents, window.money_format);
    formatted = extractContent(formatted);

    const moneySpan = document.createElement('span');
    moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal');
    moneySpan.innerText = formatted;
    document.body.appendChild(moneySpan);

    if (shouldConvertProductMoney()) {
        const currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
    }

    formatted = moneySpan.innerText;
    moneySpan.remove();

    return formatted;
}

function getProductLevelDiscountStep(levelDiscount, quantity) {
    const levelDiscountArr = levelDiscount?.levelDiscountArr;
    if (!levelDiscount?.isShowLevelDiscount || !Array.isArray(levelDiscountArr) || !levelDiscountArr.length) {
        return { current: null, next: null };
    }

    if (quantity < levelDiscountArr[0].buy_num) {
        return { current: null, next: levelDiscountArr[0] };
    }

    const lastDiscount = levelDiscountArr[levelDiscountArr.length - 1];
    if (quantity >= lastDiscount.buy_num) {
        return { current: lastDiscount, next: lastDiscount };
    }

    let current = null;
    let next = levelDiscountArr[0];

    levelDiscountArr.forEach((item, index) => {
        const nextItem = levelDiscountArr[index + 1];
        if (nextItem && quantity >= item.buy_num && quantity < nextItem.buy_num) {
            current = item;
            next = nextItem;
        }
    });

    return { current, next };
}

function getProductView(productId) {
    return document.querySelector(`.productView [data-product="${productId}"]`)?.closest('.productView');
}

function getProductQuantityInput(productView, productId) {
    return Array.from(productView?.querySelectorAll('.quantity__input[data-product="' + productId + '"]') || [])
        .find((input) => !input.closest('.hidden')) || productView?.querySelector('.quantity__input[data-product="' + productId + '"]');
}

function updateProductInstallment(productView, price) {
    if (!productView || !price) return;

    productView.querySelectorAll('[data-installment-price]').forEach((installmentPrice) => {
        installmentPrice.textContent = formatProductMoney(Math.floor(price / 4));
    });
}

function updateProductLevelDiscountBox(productView, productId, price) {
    if (!productView || !price) return;

    const variantId = document.getElementById(`product-form-${productId}`)?.querySelector('[name="id"]')?.value;
    const addButton = document.getElementById(`product-form-${productId}`)?.querySelector('[name="add"]');

    productView.querySelectorAll('[data-level-discount-box]').forEach((box) => {
        box.classList.toggle('hidden', !!addButton?.disabled);

        const variantInput = box.querySelector('[data-level-discount-variant]');
        if (variantInput && variantId) variantInput.value = variantId;

        box.querySelectorAll('[data-level-discount-option]').forEach((option) => {
            const buyNum = parseInt(option.dataset.buyNum);
            const offRate = parseFloat(option.dataset.offRate);
            if (!buyNum || Number.isNaN(offRate)) return;

            const discountedUnit = Math.ceil(price * (100 - offRate) / 100);
            const unit = option.querySelector('[data-level-discount-unit]');
            const normal = option.querySelector('[data-level-discount-normal]');
            const total = option.querySelector('[data-level-discount-total]');
            const totalNormal = option.querySelector('[data-level-discount-total-normal]');

            if (unit) unit.textContent = formatProductMoney(discountedUnit);
            if (normal) normal.textContent = formatProductMoney(price);
            if (total) total.textContent = formatProductMoney(discountedUnit * buyNum);
            if (totalNormal) totalNormal.textContent = formatProductMoney(price * buyNum);
        });
    });
}

function setProductLevelDiscountQuantity(productView, productId, quantity) {
    const inputs = Array.from(productView?.querySelectorAll('.quantity__input[data-product="' + productId + '"]') || []);
    const primaryInput = inputs.find((input) => !input.closest('.hidden')) || inputs[0];
    if (!primaryInput) return;

    primaryInput.value = quantity;
    primaryInput.dispatchEvent(new Event('change', { bubbles: true }));
    inputs.forEach((input) => {
        input.value = quantity;
    });
}

function copyTextToClipboard(text) {
    const fallbackCopy = () => {
        const field = document.createElement('textarea');
        field.value = text;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.top = '-9999px';
        document.body.appendChild(field);
        field.select();

        try {
            const copied = document.execCommand('copy');
            field.remove();
            return copied ? Promise.resolve() : Promise.reject();
        } catch (error) {
            field.remove();
            return Promise.reject(error);
        }
    };

    if (navigator.clipboard?.writeText) {
        return navigator.clipboard.writeText(text).catch(fallbackCopy);
    }

    return fallbackCopy();
}

function initProductDiscountCodeCopyControls(context = document) {
    context.querySelectorAll('[data-product-discount-copy]:not([data-product-discount-copy-ready])').forEach((button) => {
        button.dataset.productDiscountCopyReady = 'true';

        button.addEventListener('click', () => {
            const discountCode = button.dataset.discountCode;
            if (!discountCode || button.disabled) return;

            copyTextToClipboard(discountCode).then(() => {
                const originText = button.dataset.originText || button.textContent;
                button.dataset.originText = originText;
                button.textContent = 'COPIED';
                button.classList.add('disabled');
                button.disabled = true;

                window.setTimeout(() => {
                    button.textContent = originText;
                    button.classList.remove('disabled');
                    button.disabled = false;
                }, 3000);
            }).catch(() => {
                button.textContent = discountCode;
            });
        });
    });
}

function initProductLevelDiscountControls(context = document) {
    context.querySelectorAll('[data-level-discount-box]:not([data-level-discount-ready])').forEach((box) => {
        box.dataset.levelDiscountReady = 'true';

        box.querySelector('[data-level-discount-add]')?.addEventListener('click', (event) => {
            event.preventDefault();

            const productId = box.dataset.product;
            const productView = box.closest('.productView');
            const selectedInput = box.querySelector('[data-level-discount-input]:checked');
            const selectedOption = selectedInput?.closest('[data-level-discount-option]');
            const buyNum = parseInt(selectedInput?.value || selectedOption?.dataset.buyNum || 1);
            const addButton = document.getElementById(`product-form-${productId}`)?.querySelector('[name="add"]');

            setProductLevelDiscountQuantity(productView, productId, buyNum);
            addButton?.click();
        });
    });
}

function updateProductLevelDiscount(productId, quantity = null, price = null) {
    const levelDiscount = window[`product_level_discount_${productId}`];
    const productView = getProductView(productId);
    const quantityInput = getProductQuantityInput(productView, productId);
    const activeQuantity = parseInt(quantity || quantityInput?.value || 1);
    const activePrice = parseInt(price || quantityInput?.dataset.price || 0);

    initProductLevelDiscountControls(productView || document);
    updateProductInstallment(productView, activePrice);
    updateProductLevelDiscountBox(productView, productId, activePrice);

    if (!levelDiscount?.isShowLevelDiscount) return;

    const discountState = getProductLevelDiscountStep(levelDiscount, activeQuantity);

    productView?.querySelectorAll('[data-level-discount-badge]').forEach((badge) => {
        if (discountState.next) {
            badge.textContent = `Buy ${discountState.next.buy_num} for ${discountState.next.off_rate}% off!`;
            badge.classList.remove('hidden');
        } else {
            badge.classList.add('hidden');
        }
    });

    if (!productView || !activePrice) return;

    const baseTotal = activePrice * activeQuantity;
    productView.querySelectorAll('.productView-subtotal').forEach((subtotal) => {
        const baseMoney = subtotal.querySelector('.money-subtotal, .money');
        if (!baseMoney) return;

        let discountedMoney = subtotal.querySelector('.money-subtotal-discounted');
        if (!discountedMoney) {
            discountedMoney = document.createElement('span');
            discountedMoney.className = 'money-subtotal-discounted';
            baseMoney.insertAdjacentElement('afterend', discountedMoney);
        }

        if (discountState.current) {
            const discountedUnit = Math.ceil(activePrice * (100 - discountState.current.off_rate) / 100);
            discountedMoney.textContent = formatProductMoney(discountedUnit * activeQuantity);
            subtotal.classList.add('with-discounted');
        } else {
            discountedMoney.textContent = '';
            subtotal.classList.remove('with-discounted');
        }

        baseMoney.textContent = formatProductMoney(baseTotal);
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initProductDiscountCodeCopyControls();
        initProductLevelDiscountControls();
        document.querySelectorAll('[data-level-discount-box]').forEach((box) => updateProductLevelDiscount(box.dataset.product));
    });
} else {
    initProductDiscountCodeCopyControls();
    initProductLevelDiscountControls();
    document.querySelectorAll('[data-level-discount-box]').forEach((box) => updateProductLevelDiscount(box.dataset.product));
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        if (this.closest('.quick-order-list__contents')) return; 
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true });
        this.input.addEventListener('change', this.onInputChange.bind(this));

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );

        if (!this.checkHasMultipleVariants()) {
            this.initProductQuantity();
            this.checkVariantInventory();
        }
    }

    onInputChange(event) {
        event.preventDefault(); 
        var inputValue = this.input.value;
        var maxValue = parseInt(this.input.dataset.inventoryQuantity);
        var currentId = document.getElementById(`product-form-${this.input.dataset.product}`)?.querySelector('[name="id"]')?.value;
        var saleOutStock  = document.getElementById('product-add-to-cart')?.dataset.available === 'true' || false ;
        const addButton = document.getElementById(`product-form-${this.input.dataset.product}`)?.querySelector('[name="add"]');

        if(inputValue < 1) {
            inputValue = 1;

            this.input.value =  inputValue;
        }
        
        if (inputValue > maxValue && !saleOutStock && maxValue > 0) {
            var arrayInVarName = `selling_array_${this.input.dataset.product}`,
                itemInArray = window[arrayInVarName],
                itemStatus = itemInArray[currentId];
          
            if(itemStatus == 'deny') {
              inputValue = maxValue
              this.input.value = inputValue;
              const message = getInputMessage(maxValue)
              showWarning(message, 3000)
            }
        } else if (inputValue > maxValue && saleOutStock && maxValue <= 0) {
            this.input.value = inputValue;
        }

        const productId = this.input.dataset.product;
        const levelDiscount = window[`product_level_discount_${productId}`];
        const basePrice = parseInt(this.input.dataset.price);
        let actualPrice = basePrice;
        let hasDiscount = false;
        
        // 检查是否应用阶梯折扣
        if (levelDiscount?.isShowLevelDiscount && Array.isArray(levelDiscount.levelDiscountArr)) {
            const discountStep = getProductLevelDiscountStep(levelDiscount, inputValue);
            if (discountStep.current) {
                // 应用阶梯折扣
                actualPrice = Math.ceil(basePrice * (100 - discountStep.current.off_rate) / 100);
                hasDiscount = true;
            }
        }

        const formatSubtotalMoney = (value) => {
            let subtotal = Shopify.formatMoney(value, window.money_format);
            subtotal = extractContent(subtotal);

            const moneySpan = document.createElement('span');
            moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal');
            moneySpan.innerText = subtotal;
            document.body.appendChild(moneySpan);

            if (this.checkNeedToConvertCurrency()) {
                let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
            }

            subtotal = moneySpan.innerText;
            moneySpan.remove();

            return subtotal;
        };

        const subTotal = formatSubtotalMoney(inputValue * actualPrice);

        if(window.subtotal.show) {
            var text;

            if (window.subtotal.style == '1') {
                const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');

                if (pdView_subTotal) {
                    pdView_subTotal.textContent = subTotal;
                }
            }
            else if (window.subtotal.style == '2') {
                text = window.subtotal.text.replace('[value]', subTotal);
                $('#product-sticky-add-to-cart').text(text);
                if (addButton != null){
                    addButton.textContent = text;
                }
            }
        }

        // 更新 sticky 购物车价格（应用阶梯折扣）
        const thisStickyPrice = $('[data-sticky-add-to-cart] .sticky-price');
        const stickySubtotal = $('[data-sticky-add-to-cart] .sticky-price .money-subtotal');
        let stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price');

        if (stickySubtotal.length) {
            stickySubtotal.each((index, element) => {
                const moneyElement = element.querySelector('.money');
                if (moneyElement && !$('body').hasClass('disable_currencies')) {
                    moneyElement.textContent = subTotal;
                } else {
                    element.textContent = subTotal;
                }
            });
        }

        // 处理 compare price 显示
        if (hasDiscount) {
            // 有阶梯折扣，需要显示原价总价作为对比
            const comparePrice = formatSubtotalMoney(basePrice * inputValue);
            
            thisStickyPrice.addClass('has-compare-price');
            if (stickyComparePrice.length) {
                // 更新现有的 compare price
                stickyComparePrice.attr('data-compare-price', basePrice * inputValue);
                stickyComparePrice.each((index, element) => {
                    const moneyElement = element.querySelector('.money');
                    if (moneyElement && !$('body').hasClass('disable_currencies')) {
                        moneyElement.textContent = comparePrice;
                    } else {
                        element.textContent = comparePrice;
                    }
                });
            } else {
                // 创建新的 compare price 元素
                thisStickyPrice.prepend(`<s class="money-compare-price" data-compare-price="${basePrice * inputValue}"><span class="money">${comparePrice}</span></s>`);
            }
        } else if (!hasDiscount) {
            // 没有阶梯折扣，移除由阶梯折扣产生的 compare price
            thisStickyPrice.removeClass('has-compare-price');
            stickyComparePrice.remove();
        }

        updateProductLevelDiscount(this.input.dataset.product, inputValue, this.input.dataset.price);

        if (this.classList.contains('quantity__group--2') || this.classList.contains('quantity__group--3')) {
            const mainQty = document.querySelector('.quantity__group--1 .quantity__input');
            if (mainQty != null){
                mainQty.value = inputValue;
            }

            const mainQty2Exists = !!document.querySelector('.quantity__group--2 .quantity__input');
            const mainQty3Exists = !!document.querySelector('.quantity__group--3 .quantity__input');

            if (this.classList.contains('quantity__group--2') && mainQty3Exists) {
                const mainQty3 = document.querySelector('.quantity__group--3 .quantity__input');
                mainQty3.value = inputValue;
            }
            else if (this.classList.contains('quantity__group--3') && mainQty2Exists) {
                const mainQty2 = document.querySelector('.quantity__group--2 .quantity__input');
                mainQty2.value = inputValue;
            }
        }
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    checkNeedToConvertCurrency() {
        var currencyItem = $('.dropdown-item[data-currency]');
        if (currencyItem.length && typeof Currency !== 'undefined' && typeof Currency.convertAll === 'function') {
            const activeShopCurrency = typeof shopCurrency !== 'undefined' ? shopCurrency : window.shop_currency;
            return (window.show_multiple_currencies && Currency.currentCurrency != activeShopCurrency) || window.show_auto_currency;
        } else {
            return;
        }
    }
    
    checkHasMultipleVariants() {
        const arrayInVarName = `product_inven_array_${this.querySelector('[data-product]').dataset.product}`
        this.inven_array = window[arrayInVarName];
        return Object.keys(this.inven_array).length > 1
    }
        
    initProductQuantity() {
        if(this.inven_array != undefined) {
            var inven_num = Object.values(this.inven_array),
                inventoryQuantity = parseInt(inven_num);

            this.querySelector('input[name="quantity"]').setAttribute('data-inventory-quantity', inventoryQuantity);
            this.querySelector('input[name="quantity"]').dataset.inventoryQuantity = inventoryQuantity
        }
    }

    checkVariantInventory() {
        const addBtn = document.getElementById('product-add-to-cart');
        if (!addBtn) return;
        this.input.disabled = addBtn.disabled;
        this.querySelector('.btn-quantity.minus').disabled = addBtn.disabled;
        this.querySelector('.btn-quantity.plus').disabled = addBtn.disabled;
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(document.querySelector('.product-option [type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('quantity-input', QuantityInput);

class StepIndicator extends HTMLElement {
    constructor() {
        super();
        this.el = this;
        this.steps = parseInt(this.getAttribute('steps')) || 3;
        this._step = 0;
    }

    connectedCallback() {
        document.addEventListener("click", this.clickAction.bind(this));
        this.displayStep(this.step);
        this.checkExtremes();
        this.setupFinalStepInputWatcher();
    }

    get step() {
        return this._step;
    }

    set step(value) {
        this._step = value;
        this.displayStep(value);
        this.checkExtremes();
    }

    clickAction(e) {
        const button = e.target.closest('a[data-action]');
        if (!button) return;

        const actionName = button.getAttribute("data-action");
        if (actionName === "prev") this.prev();
        else if (actionName === "next") this.next();
    }

    prev() {
        if (this.step > 0) this.step--;
    }

    next() {
        if (this.step < this.steps - 1) this.step++;
    }

    checkExtremes() {
        const prevBtn = document.querySelector(`[data-action="prev"]`);
        const nextBtn = document.querySelector(`[data-action="next"]`);
        const cartBtn = document.querySelector(`[data-action="cart"]`);

        if (prevBtn) prevBtn.setAttribute("aria-disabled", this.step <= 0 ? "true" : "false");
        if (nextBtn) nextBtn.setAttribute("aria-disabled", this.step >= this.steps - 1 ? "true" : "false");

        if (cartBtn) {
            cartBtn.style.display = (this.step >= this.steps - 1) ? 'inline-block' : 'none';
            if (nextBtn) nextBtn.style.display = (this.step >= this.steps - 1) ? 'none' : 'block';
        }
    }

    displayStep(targetStep) {
        const current = "steps__step--current";
        const done = "steps__step--done";

        for (let i = 0; i < this.steps; i++) {
            const stepEl = this.querySelector(`.steps__step[data-step="${i}"]`);
            const tabEl = this.querySelector(`.tab[data-step="${i}"]`);

            stepEl?.classList.remove(current, done);
            tabEl?.classList.remove("active");

            if (i < targetStep) {
                stepEl?.classList.add(done);
            } else if (i === targetStep) {
                stepEl?.classList.add(current);
                tabEl?.classList.add("active");
            }
        }
    }

    setupFinalStepInputWatcher() {
        const lastTab = this.querySelector(`.tab[data-step="${this.steps - 1}"]`);
        if (!lastTab) return;

        const inputWrapper = lastTab.querySelector('.product-step__input');
        if (!inputWrapper) return;

        const fields = inputWrapper.querySelectorAll('input, textarea');

        const checkCompleted = () => {
            const isFilled = Array.from(fields).some(el => el.value.trim() !== '');
            const stepEl = this.querySelector(`.steps__step[data-step="${this.steps - 1}"]`);

            if (isFilled) {
                inputWrapper.classList.add('complete');
                if (stepEl?.classList.contains('steps__step--current')) {
                    stepEl.classList.remove('steps__step--current');
                    stepEl.classList.add('steps__step--done');
                }
            } else {
                inputWrapper.classList.remove('complete');
                if (stepEl?.classList.contains('steps__step--done')) {
                    stepEl.classList.remove('steps__step--done');
                    stepEl.classList.add('steps__step--current');
                }
            }
        };

        fields.forEach(field => {
            field.addEventListener('input', checkCompleted);
        });
    }
}

customElements.define("step-indicator", StepIndicator);

function hotStock(inventoryQuantity) {
    const productView = document.querySelector('.productView');
    const hotStock = productView.querySelector('.productView-hotStock');
    if(hotStock) {
        let hotStockText = hotStock.querySelector('.hotStock-text'),
            maxStock = parseFloat(hotStock.dataset.hotStock),
            textStock;

        if(inventoryQuantity > 0 && inventoryQuantity <= maxStock){
            hotStock.matches('.style-2') ? textStock  = window.inventory_text.hotStock2.replace('[inventory]', inventoryQuantity) : textStock  = window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity);
            if (hotStockText) hotStockText.innerHTML = textStock;
            hotStock.classList.remove('is-hide');
        } else {
            hotStock.classList.add('is-hide');
        }

        if (hotStock.matches('.style-2')) {
            const invenProgress = inventoryQuantity / maxStock * 100,
                hotStockProgressItem = hotStock.querySelector('.hotStock-progress-item');
            if (hotStockProgressItem) hotStockProgressItem.style.width = `${invenProgress}%`;
        }
    }
}
const hotStockNoOptions = document.querySelector('.productView .productView-hotStock[data-current-inventory]');
if (hotStockNoOptions) {
    const inventoryQuantity = parseFloat(hotStockNoOptions.dataset.currentInventory);
    hotStock(inventoryQuantity);
}


function showWarning(content, time = null) {
    if (window.warningTimeout) {
        clearTimeout(window.warningTimeout);
    }
    const warningPopupContent = document.getElementById('halo-warning-popup').querySelector('[data-halo-warning-content]')
    warningPopupContent.textContent = content
    document.body.classList.add('has-warning')

    if (time) {
        window.warningTimeout = setTimeout(() => {
            document.body.classList.remove('has-warning')
        }, time)
    }
}

function getInputMessage(maxValue) {
    var message = window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);
    return message
}
